import { combineReducers } from 'redux'
import { injectReducer } from '../../../../store/reducers'
import { injectSaga, cancelSaga } from '../../store/sagas'

export default (store) => ({
  path: 'casper-init',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CasperInit = require('./containers/CasperInitContainer').default
      const casperInitReducer = require('./modules/casperInit').default
      const saga = require('./modules/casperInit').mainSaga

      injectReducer(store, {
        key: 'casperInit',
        reducer: combineReducers({
          button: casperInitReducer
        })
      })

      injectSaga(store, { key: 'casperInit', saga })

      /*  Return getComponent   */
      cb(null, CasperInit)

    /* Webpack named bundle   */
    }, 'casperInit')
  },

  onLeave() {
    cancelSaga(store, 'casperInit')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Button/routes/CasperInit/index.js